(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Settings.Agency.User",
                { 
                    url: "/User/{userId}",
                    component: "user",
                    resolve: {
                        user: [
                            "userApi", "$transition$", function (userApi, $transition$) {
                                return userApi.get($transition$.params().userId);
                            }
                        ],
                        person: [
                            "userApi", "$transition$", function (userApi, $transition$) {
                                return userApi.getUserPerson($transition$.params().userId).then(response => {
                                    return response.Person;
                                }).catch(ng.noop);
                            }
                        ],
                        subUsers: ["user", "subUserApi", function (user, subUserApi) {
                            return subUserApi.getParents(user.Id);
                        }],
                        profilePicture: ["personApi", "person", function (personApi, person) {
                            if (!!person) {
                                return personApi.getProfilePicture(person.Id).then(function(response) {
                                        return URL.createObjectURL(response);
                                    },
                                    function() {
                                        return null;
                                    });
                            } else {
                                return null;
                            }
                        }],
                    },
                    onEnter: ["$state", "user", "person", function($state, user, person) {
                        if (!!person) {
                            $state.go("Home.Settings.Agency.User.Personal", { userId: user.Id });
                        } else {
                            $state.go("Home.Settings.Agency.User.CRM", { userId: user.Id });
                        }
                    }]
                });
        }
    ]);

    app.component("user",
        {
            templateUrl: "/App/Settings/Agency/User/user-template.html",
            controller: userController,
            bindings: {
                user: "<",
                person: "<",
                subUsers: "<",
                clientTypes: "<",
                profilePicture: "<",
                currentUser: "="
            }
        });

    userController.$inject = ["permissionService", "userApi", "personApi"];
    function userController(permissionService, userApi, personApi) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                ui: {

                },
                updateUser: updateUser,
                updateProfilePicture: updateProfilePicture,
                removeProfilePicture: removeProfilePicture,
                permissionService: permissionService,
                updatePrimaryEmailAddress: updatePrimaryEmailAddress,
                updatePrimaryPhoneNumber: updatePrimaryPhoneNumber
            });

        function updateUser() {
            $ctrl.ui.saving = true;
            return userApi.update($ctrl.user)
                .then(function () {
                    $ctrl.ui.saving = false;
                });
        }

        //PROFILE PICTURE
        function updateProfilePicture(file) {
            if (file !== null) {
                $ctrl.ui.loading = true;
                var payload = new FormData();
                payload.append("profilePic", $ctrl.profilePicture, $ctrl.profilePicture.name);

                personApi.updateProfilePicture($ctrl.person.Id, payload).then(function () {
                    personApi.getProfilePicture($ctrl.person.Id).then(function (response) {
                        $ctrl.profilePicture = URL.createObjectURL(response);
                        $ctrl.ui.loading = false;
                    });
                }, function () {
                    $ctrl.ui.loading = false;
                });
            }
        }

        function removeProfilePicture() {
            $ctrl.ui.loading = true;
            return personApi.removeProfilePicture($ctrl.person.Id).then(function () {
                $ctrl.profilePicture = null;
                $ctrl.ui.loading = false;
            });
        }
        
        function updatePrimaryEmailAddress(email) {
            return $ctrl.person.PrimaryEmailAddress = email;
        }

        function updatePrimaryPhoneNumber(phoneNum) {
            return $ctrl.person.PrimaryPhoneNumber = phoneNum;
        }
    }

})(window.app, window.angular); //jshint ignore:line